import axios from "axios";
import { MIME } from "@/common/constants";

export const resolveFullUrl = function(url, extra = undefined) {
  const parentUrl = process.env.VUE_APP_PARENT_URL;

  if (url.startsWith("https://1drv.ms")) {
    url = `${parentUrl}/proxy/${encodeURIComponent(url)}`;
  } else if (url.endsWith(".mp4") || url.includes("youtu")) {
    if (url.includes("youtu")) {
      const parts = url.split(/[/=]/);
      const youtubeId = parts[parts.length - 1];
      url = `./watch#/?v=${youtubeId}`;
    } else if (extra && extra.videoId) {
      url = `./watch#/${extra.videoId}`;
    } else {
      url = `./watch#/?u=${encodeURIComponent(url)}`;
      if (extra) {
        if (extra.name) {
          extra = extra.name;
        }
        url = `${url}&t=${encodeURIComponent(extra)}`;
      }
    }
  } else if (!(url.includes("://") || url.indexOf("//") === 0)) {
    if (!url.startsWith(parentUrl)) {
      url = parentUrl + url.replace("..", "");
    }
  }

  url = url.replace("/amituofo", "/namo-amitabha");
  url = url.replace("https://namo-amitabha.herokuapp.com/parse", "/parse");

  return url;
};

export const downloadFile = function(url, fileName) {
  console.log(`Downloading: ${fileName} from url: ${url}`);
  const parts = fileName.split(".");
  const fileType = parts[parts.length - 1];

  return new Promise((resolve, reject) => {
    axios
      .get(url, { responseType: "blob" })
      .then(response => {
        const blob = new Blob([response.data], { type: MIME[fileType] });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
        console.log(`Downloaded: ${fileName}`);
        resolve();
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};
